export const scheduleStatuses = {
    COMPLETED: 'COMPLETED',
    RENDERED: 'RENDERED',
    CANCELLED: 'CANCELLED',
    PENDING: 'PENDING',
};
